import { useMutation } from 'react-query';
import api from 'services';
import { SendCodeResponse } from 'services/requests';
import { MutationKeys } from 'constants/mutationKeys';

export const useSendCodeTo = () => {
  const mutate = async () => {
    const { data } = await api.sendCodeTo();
    return data;
  };

  const mutationKey = MutationKeys.sendCode;

  return useMutation<SendCodeResponse>(mutationKey, mutate);
};
